import axios from 'axios'
import useSWR, { SWRConfiguration } from 'swr'

import { ZipSearchResponseEntity } from '../entities/zipCloud'

const instance = axios.create({
    baseURL: "https://zipcloud.ibsnet.co.jp/api/",
    timeout: 5000,
})

instance.interceptors.response.use(response => response, error => {
    if (error.response) return error.response

    // Handle network error handling to not throw an error
    if (error.request) return Promise.reject(new Error('Network Error'))

    // Handle cancel error
    if (axios.isCancel(error)) return Promise.reject(error)

    // Handle other errors
    return Promise.reject(error)
})

export default {
    search: {
        useFetchSWR: (zipcode: string, config?: SWRConfiguration) => useSWR(
            zipcode.match(/^[0-9]{3}-?[0-9]{4}$/) ? `/search?zipcode=${zipcode}` : null,
            url => instance.get<ZipSearchResponseEntity>(url, { responseType: 'json' }), config),
    }
}